module.exports = __webpack_public_path__ + "img/ic_map.50afd15e.svg";